import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';

import { MEDIA_QUERY_DESKTOP_XS } from '../../../../utils/von-dyck-media-queries';
import { getIsStudent } from '../../../user/selectors';

export const useDisclaimer = () => {
    const isStudent = useSelector(getIsStudent);
    const shouldPinToContent = useMedia(MEDIA_QUERY_DESKTOP_XS);

    const [showDisclaimer, setShowDisclaimer] = useState(isStudent);
    const scrollBlockRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (shouldPinToContent || !isStudent) {
            return undefined;
        }

        // В декстопной версии дисклеймер пропадает при скролле
        const handleScroll = () => {
            if (!scrollBlockRef.current) {
                return;
            }

            const { scrollTop } = scrollBlockRef.current;
            setShowDisclaimer(scrollTop === 0);
        };

        const element = scrollBlockRef.current;
        if (element) {
            element.addEventListener('scroll', handleScroll);

            return () => {
                element.removeEventListener('scroll', handleScroll);
            };
        }

        return undefined;
    }, [isStudent, shouldPinToContent]);

    return {
        scrollBlockRef,
        showDisclaimer,

        /** Нужно ли показать дисклеймер как часть контента */
        shouldPinToContent,
    };
};
